import { Theme } from "mui-styles";
import { GlucRanges } from "./typehelpers";

export const getColor = (range: GlucRanges, theme: Theme) => {
  switch (range) {
    case "low":
      return "#FF0000";
    case "inRange":
      return "#00FF00";
    case "high":
      return "#FFA500";
  }
};

export const getLabels = (range: "low" | "inRange" | "high", theme: Theme) => {
  switch (range) {
    case "low":
      return "Low";
    case "inRange":
      return "In Range";
    case "high":
      return "High";
  }
};

export const colors = ["#FF0000", "#00FF00", "#0000FF"];
export const labels = ["Low", "In Range", "High"];
